import { useState } from "react";
import QuickCounter from "./QuickCounter";
import QuickOff from "./QuickOff";
import QuickSearch from "./QuickSearch";
import env, { payValue, normalPriceCount } from "../../env";
import DataModal from "../../components/Modal/dataModal";
import FormattedInputs from "../../components/Button/FormattedInputs";
import QuickShemsh from "./QuickShemsh";
import PostReq from "../../utils/PostReq";
function QuickNew(props) {
  const [selectedItem, setSelectedItem] = useState();
  const [count, setCount] = useState(1);
  const [PayInfo, setPayInfo] = useState("");
  const [showDesc, setShowDesc] = useState(0);
  const [description, setDescription] = useState("");
  const [TotalPrice, setTotalPrice] = useState("");
  const [SelectedShemsh, setSelectedShemsh] = useState();
  const token = props.token;
  const tab = props.tab;
  const user = props.user;
  const FindTotal = () => {
    const postOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify({
        title: selectedItem.title,
        ayar: PayInfo.ayar,
        weight: PayInfo.weight,
      }),
    };
    fetch(env.siteApi + "/panel/faktor/find-purchase-price", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          setTotalPrice(result.price);
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const addPayItem = () => {
    if (!selectedItem) return;
    props.setReload(0);
    const postOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify({
        userId: user && user._id,
        title: selectedItem.isShemsh
          ? SelectedShemsh.title
          : selectedItem.title,
        ...PayInfo,
        purchaseType: selectedItem.id,
        isCoin: selectedItem.isCoin && selectedItem.isCoin,
        isShemsh: selectedItem.isShemsh && selectedItem.isShemsh,
      }),
    };
    fetch(env.siteApi + "/panel/faktor/add-purchase-cart", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            setTimeout(() => props.setReload(1), 500);
            props.setError({ message: result.error, color: "brown" });
            setTimeout(
              () => props.setError({ message: "", color: "brown" }),
              3000
            );
          } else {
            setTimeout(() => props.setReload(1), 500);

            props.setCart(result);
            props.setError({ message: result.message, color: "green" });
            setTimeout(
              () => props.setError({ message: "", color: "brown" }),
              3000
            );
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const addItem = () => {
    if (!selectedItem) return;
    props.setReload(0);
    const postOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify({
        userId: user && user._id,
        date: Date.now,
        price: selectedItem.price,
        sku: selectedItem.sku,
        count: count ? count : 1,
      }),
    };
    fetch(
      env.siteApi +
        (selectedItem?.isShemsh
          ? "/panel/faktor/add-shemsh-cart"
          : "/panel/faktor/add-cart"),
      postOptions
    )
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            setTimeout(() => props.setReload(1), 500);
            props.setError({ message: result.error, color: "brown" });
            setTimeout(
              () => props.setError({ message: "", color: "brown" }),
              3000
            );
          } else {
            setTimeout(() => props.setReload(1), 500);

            props.setCart(result);
            setCount("1");
            props.setError({ message: result.message, color: "green" });
            setTimeout(
              () => props.setError({ message: "", color: "brown" }),
              3000
            );

            //setItem('')
            //setItemPrice('')
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const defAction = () => {
    if (!selectedItem) return;
    props.action({
      id: selectedItem.ItemID,
      sku: selectedItem.sku,
      title: selectedItem.title,
      count: count ? count : 1,
      price: selectedItem.priceData,
      description: "ویرایش شده",
    });
  };
  const ParamType =
    (selectedItem &&
      selectedItem.parameters &&
      selectedItem.parameters.length) % 2;
  const addNewItem = async () => {
    if (!selectedItem) return;
    const result = await PostReq({
      method: "Post",
      url: "/panel/cart/add-cart",
      body: {
        userId: user && user._id,
        isCoin: selectedItem?.isCoin,
        isShemsh: selectedItem?.isShemsh,
        isPurchase: tab,
        price: selectedItem.price,
        sku: selectedItem.sku,
        count: count ? count : 1,
        title:
          props.tab && selectedItem.isShemsh
            ? SelectedShemsh.title
            : selectedItem.title,
        ...PayInfo,
        purchaseType: selectedItem.id,
        description: description,
      },
    });
    setTimeout(() => props.setReload(1), 500);
    if (result) {
      props.setCart(result);
    }
    setCount("1");
  };
  return (
    <tr className={`input-tr ${props.tab ? "pay-tr" : ""}`}>
      <td data-cell="ردیف"></td>

      <td className="search-td" data-cell="کد کالا">
        <QuickSearch
          pType={props.pType}
          cart={props.cart}
          tab={props.tab}
          setTab={props.setTab}
          data={props.data}
          setdata={props.setdata}
          token={token}
          search={props.search}
          setSearch={props.setSearch}
          setSelectedItem={setSelectedItem}
        />
      </td>
      {props.tab && selectedItem && selectedItem.isShemsh && (
        <td data-cell="انتخاب شمش">
          <QuickShemsh
            setSelectedShemsh={setSelectedShemsh}
            SelectedShemsh={SelectedShemsh}
          />
        </td>
      )}
      {props.tab ? (
        <>
          {selectedItem &&
            selectedItem.parameters &&
            selectedItem.parameters.map((param, i) => (
              <td key={i} data-cell={param.title}>
                {" "}
                <div className="code-input-wrapper new-input">
                  {param.value == "price" ? (
                    <FormattedInputs
                      setSendBank={setPayInfo}
                      SendBank={PayInfo}
                      type={param.value}
                    />
                  ) : (
                    <input
                      className="dp-input"
                      type={param.value == "count" ? "number" : "text"}
                      placeholder={param.title}
                      onChange={(e) =>
                        setPayInfo((prevState) => ({
                          ...prevState,
                          [param.value]: e.target.value,
                        }))
                      }
                    />
                  )}
                </div>
              </td>
            ))}
        </>
      ) : (
        <td data-cell="شرح کالا">
          {selectedItem ? selectedItem.title : ""}
          <br />
          <small>{selectedItem ? selectedItem.sku : ""}</small>
        </td>
      )}

      {selectedItem && !selectedItem.isShemsh && (
        <>
          <td data-cell="وزن">
            {props.tab ? (
              selectedItem && selectedItem.weight ? (
                selectedItem.weight
              ) : (
                <div className="code-input-wrapper new-input">
                  <input
                    className="dp-input"
                    type="number"
                    placeholder="وزن"
                    onChange={(e) =>
                      setPayInfo((prevState) => ({
                        ...prevState,
                        weight: e.target.value,
                      }))
                    }
                  />
                </div>
              )
            ) : (
              <>{selectedItem && selectedItem.weight}</>
            )}
          </td>
          <td data-cell="عیار">
            {props.tab ? (
              selectedItem && selectedItem.ayar ? (
                selectedItem.ayar
              ) : (
                <div className="code-input-wrapper new-input">
                  <input
                    className="dp-input"
                    type="number"
                    placeholder="عیار"
                    onChange={(e) =>
                      setPayInfo((prevState) => ({
                        ...prevState,
                        ayar: e.target.value,
                      }))
                    }
                  />
                </div>
              )
            ) : (
              <>{selectedItem && selectedItem.ayar}</>
            )}
          </td>
        </>
      )}

      {!props.tab && selectedItem && selectedItem.isShemsh && (
        <td data-cell="تعداد">
          <div className="code-input-wrapper new-input">
            <input
              className="dp-input"
              type="number"
              placeholder="تعداد"
              onChange={(e) => setCount(e.target.value)}
            />
          </div>
        </td>
      )}

      {selectedItem && !selectedItem.isShemsh && (
        <td
          data-cell="مبلغ واحد"
          className={selectedItem && selectedItem.isCoin ? "long-td" : ""}
        >
          {selectedItem
            ? normalPriceCount(
                selectedItem.priceDetail && selectedItem.priceDetail.unitPrice
              )
            : ""}
        </td>
      )}

      {props.tab ? (
        selectedItem && !selectedItem.isCoin && !selectedItem.isShemsh ? (
          <td data-cell="مبلغ کل" className={ParamType ? "long-td" : ""}>
            {selectedItem ? (
              TotalPrice ? (
                normalPriceCount(TotalPrice)
              ) : (
                <button className="total-btn" onClick={FindTotal}>
                  محاسبه قیمت
                </button>
              )
            ) : (
              ""
            )}
          </td>
        ) : (
          <></>
        )
      ) : (
        <td data-cell="مبلغ کل">
          {selectedItem ? normalPriceCount(selectedItem.price) : ""}
        </td>
      )}
      <td className={selectedItem && selectedItem.isShemsh ? "long-td" : ""}>
        <div className="more-btn">
          <i className="fa-solid fa-comment" onClick={() => setShowDesc(1)}></i>
          {/* {props.tab ? (
            <i className="fa-solid fa-plus" onClick={addPayItem}></i>
          ) : (
            <i
              className="fa-solid fa-plus"
              onClick={props.action ? defAction : addItem}
            ></i>
          )} */}
          <i className="fa-solid fa-plus" onClick={addNewItem}></i>
        </div>
        {showDesc ? (
          <DataModal
            action={(e) => setDescription(e)}
            close={() => setShowDesc(0)}
            color="darkblue"
            buttonText="ثبت توضیحات"
            def={description}
            title={"افزودن توضیحات"}
          />
        ) : (
          <></>
        )}
      </td>
    </tr>
  );
}
export default QuickNew;
